import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const postDiscussionModel = data => {
  return dispatch => {
    dispatch({ type: "POST_DISCUSSION_MODEL_LOADING" });
    api
      .discussionModelPost(data)
      .then(resp => {
        if (data.id) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "PostDiscussionModelErrorAlertTitle",
          "Virhe keskustelumallin tallennuksessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_DISCUSSION_MODEL_SUCCEEDED",
  payload: { discussionmodel: data },
});

const postEditSucceeded = data => ({
  type: "POST_DISCUSSION_MODEL_EDIT_SUCCEEDED",
  payload: { discussionmodel: data },
});

const operationFailed = () => ({
  type: "POST_DISCUSSION_MODEL_FAIL",
});
